import type { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import { StyledCursive } from './styled';

export type CursiveProps = {
    children?: string;
    type: FontTypes;
};

const Cursive: FC<CursiveProps> = ({ children, type }: CursiveProps) => (
    <StyledCursive content={children} type={type} asElement="span" />
);

export default Cursive;
